// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-navigation-spacer[data-v-c8233ec5] {
  flex-shrink: 0;
  order: 1;
  height: 22px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-76dd9f11.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,QAAQ;EACR,YAAY;AACd","sourcesContent":[".app-navigation-spacer[data-v-c8233ec5] {\n  flex-shrink: 0;\n  order: 1;\n  height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
